// extracted by mini-css-extract-plugin
module.exports = {"pagination":"style_pagination__3xzg8","style_pagination__2lp3I":"style_style_pagination__2lp3I__1wWxn"};